const PLATFORM_NAME = "Child+智慧平台";

export function buildReportPrintTitle(studentName: string, reportType: string): string {
  const safeStudentName = sanitizeFilenamePart(studentName) || "儿童";
  const safeReportType = sanitizeFilenamePart(reportType) || "报告";
  return `${safeStudentName}-${safeReportType}-${PLATFORM_NAME}`;
}

export function printReport(studentName: string, reportType: string): void {
  const previousTitle = document.title;
  document.title = buildReportPrintTitle(studentName, reportType);
  try {
    window.print();
  } finally {
    document.title = previousTitle;
  }
}

function sanitizeFilenamePart(value: string): string {
  return value
    .trim()
    .replace(/[\\/:*?"<>|]+/g, "-")
    .replace(/\s+/g, " ")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}
